module.exports = __webpack_public_path__ + "media/tips/01_logo-2b46f275.png";